
import Vue from "vue";
import {
  Address,
  AddressType, Contact,
  contactApi, ContactPerson,
  PhoneNumber,
  PhoneNumberType,
} from "@/api/contacts";
import { ValidationProvider } from "vee-validate";
import EventBus from "@/utils/EventBus";
import {SnackbarMsgEvent} from "@/layout/Layout.vue";
// eslint-disable-next-line
const ContactPhonenumber: any = Vue.extend({
  name: "ContactPhonenumber",
  components: {
    ValidationProvider,
  },
  props: {
    phoneNumber: {
      type: Object as () => PhoneNumber,
      required: false,
    },
    contact: {
      type: Object as () => Contact,
      required: false,
    },
    phoneNumberRef: {
      type: String,
      required: false,
    },
    contactRef: {
      type: String,
      required: false,
    },
    phoneNumberIndex: {
      type: Number,
    },
    removeable: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPhoneNumber: {} as PhoneNumber,
      contactPersons: [] as ContactPerson[],
      init: true,
    };
  },
  computed: {
    phoneNumberTypes(): { value: string; text: string }[] {
      return Object.keys(PhoneNumberType).map((k) => ({
        value: k,
        text: this.$t(`enum.phoneNumberType.${k}`) as string,
      }));
    },
  },
  watch: {
    contact: {
      handler: async function () {
        if (this.contact) {
          this.contactPersons = [];
          this.contactPersons.push(...this.contact.contactPersons);
          this.contactPersons.push(...this.contact.externalContactPersons);
        }
      },
      immediate: true,
    },
    currentPhoneNumber: {
      handler: function () {
        if (!this.init) {
          this.$emit("changed", this.currentPhoneNumber);
        }
        this.init = false;
      },
      deep: true,
    },
    phoneNumber: {
      handler: async function () {
        if (this.phoneNumber) {
          this.currentPhoneNumber = this.phoneNumber;
          if (typeof this.currentPhoneNumber.number !== "string") {
            this.currentPhoneNumber.number = "";
          }
          this.init = false;
        }
      },
      immediate: true,
    },
    phoneNumberRef: {
      handler: function () {
        if (this.phoneNumberRef && this.contactRef) {
          contactApi
            .getPhoneNumberById(this.contactRef, this.phoneNumberRef)
            .then((result: PhoneNumber) => {
              this.currentPhoneNumber = result;
            });
        }
      },
      immediate: true,
    },
    contactRef: {
      handler: function () {
        if (this.phoneNumberRef && this.contactRef) {
          contactApi
            .getPhoneNumberById(this.contactRef, this.phoneNumberRef)
            .then((result: PhoneNumber) => {
              this.currentPhoneNumber = result;
            });
        }
      },
      immediate: true,
    },
  },
  methods: {
    copyToClipboard() {
      if( this.currentPhoneNumber) {
        navigator.clipboard.writeText(this.currentPhoneNumber.number).then(function() {
          EventBus.$emit("snackbarInfosTo", { msg: "Telefonnummer erfolgreich kopiert" } as SnackbarMsgEvent);
        }, function(err) {
          EventBus.$emit("snackbarInfosTo", { msg: "Telefonnummer konnte nicht kopiert werden "+err } as SnackbarMsgEvent);
        });
      }
    },
    getPhoneNumberTypeIcon(phoneNumberType: PhoneNumberType) {
      if (phoneNumberType === PhoneNumberType.MOBILE) {
        return "mdi-cellphone";
      } else if (phoneNumberType === PhoneNumberType.LANDLINE) {
        return "mdi-deskphone";
      } else if (phoneNumberType === PhoneNumberType.FAX) {
        return "mdi-fax";
      } else if (phoneNumberType === PhoneNumberType.BUSINESS) {
        return "mdi-card-account-phone";
      }
      return "mdi-phone-classic";
    },
    fireChangeEvent() {
      this.$emit("change", this.currentPhoneNumber);
    },
    removePhoneNumber() {
      this.$emit("removePhoneNumber");
    },
  },
});
export default ContactPhonenumber;
